<div *ngIf="credolabLoading" class="text-center py-4">
    <div class="spinner-border text-primary"></div>
    <p class="mt-2 text-muted">Cargando config Credolab…</p>
</div>

<div *ngIf="!credolabLoading && credolabNotSeeded" class="alert alert-warning">
    <i class="fa fa-exclamation-triangle me-2"></i>
    <strong>Configuración no sembrada.</strong>
    Ejecute <code>node seed_approval_policy.js</code> en kredit-api-MT.
</div>

<div *ngIf="!credolabLoading && !credolabNotSeeded && credolabData" class="card">
    <div class="card-body">

        <!-- Interruptor de modelo -->
        <div class="row g-3 mb-4">
            <div class="col-md-4">
                <label class="form-label fw-bold">
                    Modelo que decide
                    <i class="fa fa-info-circle text-muted ms-1"
                       title="Credolab manda los dos modelos y los dos se guardan siempre. Esto define cuál gobierna la aprobación. Si el elegido no viene en el upload, se usa el otro."></i>
                </label>
                <select class="form-select"
                        [(ngModel)]="thresholdsForm.scoreModel"
                        [disabled]="credolabSaving">
                    <option [ngValue]="null">Automático (modelo anterior)</option>
                    <option [ngValue]="'score_v2'">Modelo nuevo (score_v2)</option>
                    <option [ngValue]="'score'">Modelo anterior (score)</option>
                </select>
            </div>
        </div>

        <!-- Umbrales propios por modelo -->
        <label class="form-label fw-bold mb-2">
            Umbrales por modelo
            <i class="fa fa-info-circle text-muted ms-1"
               title="Vacío = hereda el umbral global. El modelo que no decide se evalúa igual y queda registrado en la ficha del cliente."></i>
        </label>
        <div class="row g-3 mb-4">
            <div class="col-md-6" *ngFor="let code of MODEL_ORDER">
                <div class="border rounded p-3 h-100">
                    <div class="d-flex align-items-center mb-2">
                        <span class="fw-medium">{{ MODEL_LABELS[code] }}</span>
                        <span class="badge bg-primary ms-2" *ngIf="esModeloDecisivo(code)">Decide</span>
                        <span class="badge bg-light text-muted ms-2" *ngIf="!esModeloDecisivo(code)">Referencia</span>
                        <small class="text-muted ms-auto" title="Umbrales en uso para este modelo">
                            ≥ {{ getEffective(code, 'minScore') ?? '—' }} ·
                            ≤ {{ getEffective(code, 'maxProbability') ?? '—' }}
                        </small>
                    </div>
                    <div class="row g-2">
                        <div class="col-6">
                            <input type="number" class="form-control form-control-sm"
                                   [(ngModel)]="modelsForm[code].minScore"
                                   min="0" max="1000" step="1"
                                   placeholder="Score mín. (global)"
                                   title="Score mínimo propio de este modelo. Vacío hereda el global."
                                   [disabled]="credolabSaving">
                        </div>
                        <div class="col-6">
                            <input type="number" class="form-control form-control-sm"
                                   [(ngModel)]="modelsForm[code].maxProbability"
                                   min="0" max="1" step="0.01"
                                   placeholder="Prob. máx. (global)"
                                   title="Probabilidad máxima propia de este modelo. Vacío hereda el global."
                                   [disabled]="credolabSaving">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <label class="form-label fw-bold mb-2">
            Umbrales globales
            <i class="fa fa-info-circle text-muted ms-1"
               title="Los hereda el modelo que no tenga umbrales propios."></i>
        </label>
        <div class="row g-3">
            <div class="col-md-4">
                <label class="form-label fw-bold">
                    Score mínimo <small class="text-muted">(0-1000)</small>
                    <i class="fa fa-info-circle text-muted ms-1" title="Credolab aprueba si el score es ≥ a este valor."></i>
                </label>
                <input type="number" class="form-control"
                       [(ngModel)]="thresholdsForm.minScore"
                       min="0" max="1000" step="1"
                       [disabled]="credolabSaving || thresholdsForm.evaluationMode === 'PROBABILITY_ONLY'">
                <small class="form-text text-muted" *ngIf="thresholdsForm.evaluationMode === 'PROBABILITY_ONLY'">
                    <i class="fa fa-info-circle me-1"></i> No aplica en este modo.
                </small>
            </div>
            <div class="col-md-4">
                <label class="form-label fw-bold">
                    Probabilidad máxima <small class="text-muted">(0-1)</small>
                    <i class="fa fa-info-circle text-muted ms-1" title="Credolab aprueba si la probabilidad de default es ≤ a este valor."></i>
                </label>
                <input type="number" class="form-control"
                       [(ngModel)]="thresholdsForm.maxProbability"
                       min="0" max="1" step="0.01"
                       [disabled]="credolabSaving || thresholdsForm.evaluationMode === 'SCORE_ONLY'">
                <small class="form-text text-muted" *ngIf="thresholdsForm.evaluationMode === 'SCORE_ONLY'">
                    <i class="fa fa-info-circle me-1"></i> No aplica en este modo.
                </small>
            </div>
            <div class="col-md-4">
                <label class="form-label fw-bold">
                    Modo de evaluación
                    <i class="fa fa-info-circle text-muted ms-1" title="Define qué umbral(es) gobiernan el resultado de Credolab."></i>
                </label>
                <select class="form-select"
                        [(ngModel)]="thresholdsForm.evaluationMode"
                        [disabled]="credolabSaving">
                    <option [ngValue]="'BOTH'">Ambos umbrales deben pasar</option>
                    <option [ngValue]="'EITHER'">Basta con que uno pase</option>
                    <option [ngValue]="'SCORE_ONLY'">Solo score decide</option>
                    <option [ngValue]="'PROBABILITY_ONLY'">Solo probabilidad decide</option>
                </select>

            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <small class="text-muted">
                    Última modificación:
                    <strong>{{ credolabData.updatedBy || '—' }}</strong>
                    el <strong>{{ credolabData.updatedAt | date:'dd/MM/yyyy HH:mm' }}</strong>
                </small>
            </div>
        </div>

        <button class="btn btn-primary mt-3"
                (click)="saveThresholds()"
                [disabled]="credolabSaving">
            <span *ngIf="credolabSaving" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!credolabSaving" class="fa fa-save me-1"></i>
            Guardar umbrales
        </button>
    </div>
</div>
